module.exports = __webpack_public_path__ + "static/airgate-black-d36012f04ad02f5e9f61b56564d403cf.png";